var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [_c("span", [_vm._v("开心社区全局配置")])]
          ),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                model: _vm.configForm,
                "label-width": "180px",
                size: "small",
              },
            },
            [
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("开心果设置（按专区分别配置）"),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "企业活动专区倍数" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 1, max: 100 },
                    model: {
                      value: _vm.configForm.kx_happy_fruit_multiple_enterprise,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.configForm,
                          "kx_happy_fruit_multiple_enterprise",
                          $$v
                        )
                      },
                      expression:
                        "configForm.kx_happy_fruit_multiple_enterprise",
                    },
                  }),
                  _c("span", { staticClass: "form-tip" }, [
                    _vm._v(
                      "企业活动专区订单：消费金额 × 该倍数 = 赠送待释放开心果"
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商家赋能专区倍数" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 1, max: 100 },
                    model: {
                      value: _vm.configForm.kx_happy_fruit_multiple_merchant,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.configForm,
                          "kx_happy_fruit_multiple_merchant",
                          $$v
                        )
                      },
                      expression: "configForm.kx_happy_fruit_multiple_merchant",
                    },
                  }),
                  _c("span", { staticClass: "form-tip" }, [
                    _vm._v(
                      "商家赋能专区订单：消费金额 × 该倍数 = 赠送待释放开心果"
                    ),
                  ]),
                ],
                1
              ),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("佣金分配比例"),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "佣金（复购额度）比例(%)" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0, max: 100 },
                    model: {
                      value: _vm.configForm.kx_commission_ratio,
                      callback: function ($$v) {
                        _vm.$set(_vm.configForm, "kx_commission_ratio", $$v)
                      },
                      expression: "configForm.kx_commission_ratio",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "余额比例(%)" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0, max: 100 },
                    model: {
                      value: _vm.configForm.kx_balance_ratio,
                      callback: function ($$v) {
                        _vm.$set(_vm.configForm, "kx_balance_ratio", $$v)
                      },
                      expression: "configForm.kx_balance_ratio",
                    },
                  }),
                  _c("span", { staticClass: "form-tip" }, [
                    _vm._v("佣金比例 + 余额比例 应等于 100%"),
                  ]),
                ],
                1
              ),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("提现设置"),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "提现手续费(%)" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0, max: 100 },
                    model: {
                      value: _vm.configForm.kx_extract_fee_rate,
                      callback: function ($$v) {
                        _vm.$set(_vm.configForm, "kx_extract_fee_rate", $$v)
                      },
                      expression: "configForm.kx_extract_fee_rate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "最低提现金额(元)" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0, precision: 2 },
                    model: {
                      value: _vm.configForm.kx_min_extract_amount,
                      callback: function ($$v) {
                        _vm.$set(_vm.configForm, "kx_min_extract_amount", $$v)
                      },
                      expression: "configForm.kx_min_extract_amount",
                    },
                  }),
                ],
                1
              ),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("代理/拼团大使条件"),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "最低直推人数" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0 },
                    model: {
                      value: _vm.configForm.kx_agent_min_direct,
                      callback: function ($$v) {
                        _vm.$set(_vm.configForm, "kx_agent_min_direct", $$v)
                      },
                      expression: "configForm.kx_agent_min_direct",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "最低\n        团队消费(元)" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0, precision: 2 },
                    model: {
                      value: _vm.configForm.kx_agent_min_team_consume,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.configForm,
                          "kx_agent_min_team_consume",
                          $$v
                        )
                      },
                      expression: "configForm.kx_agent_min_team_consume",
                    },
                  }),
                ],
                1
              ),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("收款码管理"),
              ]),
              _c("el-form-item", { attrs: { label: "收款码图片" } }, [
                _c(
                  "div",
                  { staticClass: "qrcode-area" },
                  [
                    _vm.configForm.kx_qr_code_image
                      ? _c("el-image", {
                          staticStyle: { width: "150px", height: "150px" },
                          attrs: {
                            src: _vm.getImageUrl(
                              _vm.configForm.kx_qr_code_image
                            ),
                            fit: "contain",
                          },
                          on: { error: _vm.handleImageError },
                        })
                      : _c("div", { staticClass: "qrcode-placeholder" }, [
                          _vm._v("暂无收款码"),
                        ]),
                    _c(
                      "div",
                      { staticStyle: { "margin-top": "10px" } },
                      [
                        _c(
                          "el-upload",
                          {
                            attrs: {
                              action: _vm.uploadAction,
                              name: "multipart",
                              data: { model: "payment", pid: 0 },
                              "show-file-list": false,
                              "on-success": _vm.handleQrCodeSuccess,
                              accept: "image/*",
                            },
                          },
                          [
                            _c(
                              "el-button",
                              { attrs: { size: "small", type: "primary" } },
                              [_vm._v("上传/更换收款码")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("邀请码设置"),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "平台默认邀请码" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { placeholder: "请输入平台默认邀请码" },
                    model: {
                      value: _vm.configForm.kx_default_invite_code,
                      callback: function ($$v) {
                        _vm.$set(_vm.configForm, "kx_default_invite_code", $$v)
                      },
                      expression: "configForm.kx_default_invite_code",
                    },
                  }),
                  _c("span", { staticClass: "form-tip" }, [
                    _vm._v("散户未填写邀请码时，自动使用该邀请码绑定直推关系"),
                  ]),
                ],
                1
              ),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("联系方式设置"),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "平台联系电话" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { placeholder: "请输入平台联系电话" },
                    model: {
                      value: _vm.configForm.kx_platform_phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.configForm, "kx_platform_phone", $$v)
                      },
                      expression: "configForm.kx_platform_phone",
                    },
                  }),
                  _c("span", { staticClass: "form-tip" }, [
                    _vm._v("用户在小程序端可查看此号码联系平台"),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["admin:kx:config:save"],
                          expression: "['admin:kx:config:save']",
                        },
                      ],
                      attrs: { type: "primary", size: "medium" },
                      on: { click: _vm.handleSave },
                    },
                    [_vm._v("保存配置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }